<template>
  <div class="about" v-html="content"></div>
</template>

<script>
export default {
  data() {
    return {
      content:''
    }
  },
  methods:{
    async created() {
      let res = await this.$apis.loginServe.getPrivacy();
      this.content = res.content.detail[0].content;
    },
  },
  mounted() {
    document.title = '隐私政策'
    this.created()
  }
};
</script>

<style scoped lang="scss">
.about {
  margin: 0 auto;
  padding: 50px;
  width: 1200px;
  min-height: 840px;
  background: #ffffff;
  border: 1px solid #a3cbe7;
  border-radius: 10px;
  font-size: 15px;
  color: #333;
  line-height: 30px;
  & .top{
    & p{
      text-indent: 30px;
    }
    & .overstriking{
      font-weight: bold;
      font-size: 17px;
    }
  }
  & .h{
    text-align: center;
    margin-top: 50px;
  }
  & .conent{
    & li{
      margin-top: 40px;
      & h2{
        font-weight: bold;
        margin-bottom: 10px;
      }
      & p{
        text-indent: 30px;
        & span{
          font-weight: bold;
          font-size: 15px;
          font-family:  Microsoft YaHei;
        }
      }
    }
  }
}
/* h3 {
  font-size: 18px;
  font-family: PingFangSC-Regular;
  color: #333333;
  text-align: center;
}
h4{
  color: #333;
  font-size: 15px;
}
ul li p{
  font-size: 14px;
}
ul li{
  margin-top: 30px;
  line-height: 30px;
}
.but{
  width: 150px;
  height: 40px;
  margin: 0 auto;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #263D78;
  border-radius: 10px;
  cursor:pointer;
} */

</style>